<template>
    <section
        :data-mui-theme="theme"
        class="slice slice-content-columns slice-content-columns--default"
        aria-label="content-columns"
        data-testid="slice-content-columns-default"
    >
        <div class="slice-content">
            <ContentColumsLine :columns="columns" :index="0" class="slice-body slice-content-columns-line--with-single-line" />
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {ContentColumnsSlice} from '@prismicio-types';
    import ContentColumsLine from '../components/ContentColumsLine.vue';

    type ContentColumnsDefaultInZone = Extract<ContentColumnsSlice, {variation: 'default'}>;

    const props = defineProps(getSliceComponentProps<ContentColumnsDefaultInZone>());

    const columns = computed(() => props.slice.primary.columns ?? []);

    const theme = computed(() => props.slice.primary.theme);
</script>
